module.exports = __webpack_public_path__ + "assets/img/xfe-layer-2-6618c393.png";